import { Injectable } from '@angular/core';
import { SprintfulRecordResponse } from 'src/app/shared/models/sprintful/sprintful.model';
import { AgendaSigning } from '../../domain/models/agenda-signing.model';

@Injectable({
  providedIn: 'root',
})
export class AgendaSigningMapperService {

  toAgendaSigning(item: SprintfulRecordResponse): AgendaSigning {
    return {
      email: item.correo || '-',
      company: item.empresa || '-',
      reservedDate: item.fechaReservada || '-',
      createdDate: item.fechaCreada || '-',
      notary: item.notaria || '-',
      recordId: item.recordId || '-',
    };
  }
}
